import {
  GET_DIVISION_RATE_WATCHER,
  GET_DIVISION_RATE_SUCCESS,
  GET_DIVISION_RATE_FAILED,
} from "./constants"

export function getDivisionRateWatcher(payload) {
  return {
    type: GET_DIVISION_RATE_WATCHER,
    payload,
  }
}

export function getDivisionRateSuccess(payload) {
  return {
    type: GET_DIVISION_RATE_SUCCESS,
    payload,
  }
}

export function getDivisionRateFailed() {
  return { type: GET_DIVISION_RATE_FAILED }
}
